export default "__VITE_ASSET__D0b6cHHc__"